<template>
  <div
    class="d-flex position-relative cursor-pointer"
    data-testid="searchbar-player-item"
    @mousedown="onCardClick()"
  >
    <v-container fluid v-if="player" class="px-1 pt-1 pb-2">
      <v-row>
        <v-col cols="2" class="px-3 py-0 d-flex justify-center align-center">
          <img
            :src="
              'https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/faces/' + (player.playerId || player.id)  + '.png'
            "
            :height="46"
            contain
            @error="onImageLoadFailure($event, 'player')"
          />
        </v-col>
        <v-col
          cols="10"
          class="pl-2 pr-0 py-0 d-flex flex-column justify-center"
        >
          <div class="d-flex flex-column">
            <div class="d-flex align-center justify-space-between">
              <div
                class="d-flex flex-grow-1 justify-space-between justify-sm-start"
              >
                <span
                  class="body-2 text-ellipsis font-weight-medium" :class="$vuetify.theme.dark ? 'primary--text' : 'secondary--text text--darken-2'"
                  v-bind:style="{ 'max-width': (embedded || truncateName) && $vuetify.breakpoint.lgAndDown ? '75px' : 'auto' }"
                  >{{ (player.playerName || player.name) }}</span
                >
                <div
                  class="ml-1 d-flex px-1 w-20 justify-end justify-sm-start mr-1 mr-sm-0"
                >
                  <DriblabCountryFlag :iso="player.cC" ></DriblabCountryFlag>
                  <DriblabCountryFlag :iso="player.sCC" v-if="player.sCC" ></DriblabCountryFlag>
                </div>
              </div>
              <div class="d-flex" v-if="!$vuetify.breakpoint.smAndDown">
                <small class="font-weight-bold primary--text mx-2">
                  <div class="d-flex">
                    <v-chip color="pink" x-small
                    class="font-weight-bold white--text" v-if="!player.male">W</v-chip>
                    <span class="" v-if="player.male">{{currentUserCurrencySymbol}}</span>
                    <h4
                      class="ml-1"
                      v-if="player.male"
                      v-bind:class="{ 'mr-1': player.marketTrend }"
                    >
                      {{ (player.mv * 1000) | formatCash(currentUserRate) }}
                    </h4>
                    <v-icon
                      v-if="player.marketTrend === 'up' && !embedded"
                      color="green"
                      small
                      >trending_up</v-icon
                    >
                    <v-icon
                      v-if="player.marketTrend === 'same' && !embedded"
                      color="blue"
                      small
                      >drag_handle</v-icon
                    >
                    <v-icon
                      v-if="player.marketTrend === 'down' && !embedded"
                      color="red"
                      small
                      >trending_down</v-icon
                    >
                  </div>
                </small>
              </div>
            </div>
            <div class="d-flex align-center justify-space-between mt-n1">
              <div class="d-flex justify-start align-center">
                <div class="d-flex">
                  <v-chip
                    class="monospace-font"
                    style="height: 20px; margin: 1px"
                    :color="getPositionChip(player.pos)"
                    text-color="white"
                    small
                    >{{ getPositionCode(player.pos) }}</v-chip
                  >
                  <v-chip
                    class="monospace-font"
                    v-if="player.pos2 && player.pos2 !== null"
                    style="height: 20px; margin: 1px"
                    :color="getPositionChip(player.pos2)"
                    text-color="white"
                    small
                    >{{ getPositionCode(player.pos2) }}</v-chip
                  >
                </div>
                <div
                  class="ml-2 body-2 text-ellipsis"
                  v-if="!$vuetify.breakpoint.smAndDown"
                  v-bind:style="{'max-width': $vuetify.breakpoint.lgAndDown ? '60px' : 'auto'}"
                >
                  <small class="primary--text text-ellipsis"
                    >{{ player.age }}
                    <span class="font-weight-light text-ellipsis">{{ $t("squadBuilder.yearsOld") }}</span>
                    
                  </small>
                  <img
                        v-if="getFootImage(player.footId || player.f)"
                        :src="getFootImage(player.footId || player.f)"
                        alt=""
                        class="foot-icon ml-1 mb-1"
                      />  
                </div>
              </div>
              <div class="my-1 z-3 ml-1 text-ellipsis" v-bind:style="{'max-width': $vuetify.breakpoint.lgAndDown ? '85px' : 'auto'}">
                <span class="nav-link d-flex align-center w-100" :class="$vuetify.theme.dark ? 'primary--text' : 'secondary--text text--darken-2'">
                  <img
                    :src="
                      'https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/' +
                      (player.teamId || player.tId) +
                      '.png'
                    "
                    style="height: 22px; width: 22px"
                    @error="onImageLoadFailure($event, 'team')"
                  />
                  <div
                    class="mx-2 body-2 text-ellipsis"
                    v-bind:style="{ 'max-width': embedded ? '60px' : 'auto' }"
                  >
                    {{ player.teamName || player.tName}}
                  </div>
                </span>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>

import { formatCash, getChipColorByPosition,getCurrencies,getPositionCode } from "../../utils/functions";
import DriblabCountryFlag from '../base/DriblabCountryFlag';

export default {
  name: "PlayerSearchItem",
  components: {
    DriblabCountryFlag
  },
  filters: {
    formatCash(n,rate) {
      return formatCash(n * rate)
    }
  },
  props: {
    player: {
      type: Object,
      default: false,
    },
    allowRouter: {
      type: Boolean,
      default: false,
    },
    routerNewTab: {
      type: Boolean,
      default: false,
    },
    embedded: {
      type: Boolean,
      default: false,
    },
    truncateName: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    currentUserCurrency(){
      return this.$store.getters["auth/currency"];
    },
    currentUserRate(){
      let rate = this.currentUserCurrency === "EUR" ? 1 : this.$store.getters["exchange/rates"][this.$store.getters["auth/currency"]];
      return rate ? rate : 1;
    },
    currencies(){
      return getCurrencies();
    },
    currentUserCurrencySymbol(){
      let currentCurrencyObj = _.find(this.currencies,(c) => c.code === this.currentUserCurrency)
      return currentCurrencyObj.symbol;
    }
  },
  methods: {
    toOneDecimal: function (value) {
      return value && !isNaN(value) ? value.toFixed(1) : 0;
    },
    getPositionChip(position) {
      return getChipColorByPosition(position);
    },
    onImageLoadFailure(event, type) {
      if (type === "league" || type === "team") {
        event.target.src = "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png";
      } else if (type === "player") {
        event.target.src =
          `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/faces/0_${this.player.male === false ? 'f' : 'm'}.png`;
      }
    },
    onCardClick() {
      if (this.allowRouter) {
        if(this.routerNewTab){
          let route = this.$router.resolve({ name: "player", params: { id: (this.player.playerId || this.player.id) }});
          window.open(route.href, '_blank')
        }else{
          this.$router.push({ name: "player", params: { id: (this.player.playerId || this.player.id) }});
        }
      }
    },
    getPositionCode(position) {
      return getPositionCode(this.currentUser.fieldPositionCodeId, position);
    },
    getFootImage(footId) {

      const baseUrl = 'https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/assets';
      const footImages = {
        8: 'left_foot.png',
        9: 'both_feet.png',
        10: 'right_foot.png'
      };
      
      return footImages[footId] ? `${baseUrl}/${footImages[footId]}` : null;
    },
  },
};
</script>
<style lang="scss" scoped>
  .foot-icon {
    width: 18px;
    height: 18px;
    object-fit: contain;
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/views/player/PlayerSearchItem.vue